import React from 'react'
import { Button } from 'reactstrap'
import styled from 'styled-components'

export const generateButton = (button, click) => {
  switch (button) {
    case 'success': {
      return <Button color='success' onClick={ () => click() }>OK</Button>
    }
    case 'error': {
      return <Button color='warning' onClick={ () => click() }>Try Again</Button>
    }
    case 'discard': {
      return (
        <div>
          <CustomButton color='danger' onClick={ () => click('discard') }>Discard</CustomButton>
          <CustomButton onClick={ () => click('cancel') }>Cancel</CustomButton>
        </div>
      )
    }
    default:
      return null
  }
}

const CustomButton = styled(Button)`
  margin-right: 10px ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
`



// WEBPACK FOOTER //
// ./src/components/standard-cost-price/helpers/button.js